import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import ProjectsPage from '../components/ProjectsPage.vue'
import PublicationsPage from '../components/PublicationsPage.vue'
import MiniGameListPage from '../components/MiniGameListPage.vue'
import ColorSpottingGame from '../components/mini-games/ColorSpottingGame.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/projects',
    name: 'Projects',
    component: ProjectsPage
  },
  {
    path: '/publications',
    name: 'Publications',
    component: PublicationsPage
  },
  {
    path: '/mini-games',
    name: 'MiniGameList',
    component: MiniGameListPage
  },
  {
    path: '/mini-games/color-spotting-game',
    name: 'ColorSpottingGame',
    component: ColorSpottingGame
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.PUBLIC_URL,
  routes,
  scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  document.title = `${process.env.VUE_APP_TITLE} - ${to.name}`
  next()
})

export default router
